module.exports = __webpack_public_path__ + "img/protractor.98ae77eb.svg";